import script from "./FinanceAdvertiserView.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceAdvertiserView.vue?vue&type=script&setup=true&lang=js"

import "./FinanceAdvertiserView.vue?vue&type=style&index=0&id=6db7afc4&lang=css"

const __exports__ = script;

export default __exports__